/** Pure display helpers for the two-way SMS pages (plan §9.5 copy where it exists). */

export function formatSmsTime(iso: string | null | undefined): string {
  if (!iso) {
    return "—";
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return "—";
  }
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export const SMS_ATTACHMENT_LINE =
  "Attachment received (image). Viewing attachments isn't available. Ask the member for the details in text.";

/**
 * Small text label for a keyword message; null for an ordinary message. possible_opt_out and
 * opt_in_request use the §9.5 copy; opt_out and help have no §9.5 copy, so they get a plain label.
 */
export function smsKeywordLabel(
  classification: string | null,
  suppressed: boolean,
): string | null {
  switch (classification) {
    case "opt_out":
      return "Opt-out keyword";
    case "help":
      return "HELP keyword";
    case "possible_opt_out":
      return "This reply needs a consent review.";
    case "opt_in_request":
      return suppressed
        ? "Re-subscription requested. Sending is still blocked. Review and record the member's request."
        : "Re-subscription request received. Review the request before changing consent.";
    default:
      return null;
  }
}

/** Delivery state of a staff-sent message (plain words; "accepted" is not "delivered"). */
export function smsOutboundStateLabel(
  state: string | null | undefined,
): string {
  switch (state) {
    case "delivered":
      return "Delivered";
    case "accepted":
      return "Sent";
    case "failed_definitive":
      return "Not delivered";
    case "uncertain":
      return "Delivery unconfirmed";
    case "pending":
      return "Sending";
    default:
      return "Status unknown";
  }
}
